import AboutBtn from "../../../components/sub/AboutBtn";
import SubTitle from "../../../components/sub/SubTitle";

const AboutCompany = () => {
  const mapList = [
    "강남",
    "서초",
    "송파",
    "수원",
    "용인",
    "화성",
    "하남",
    "고양",
    "의정부",
    "평택",
    "성남",
    "인천",
    "강원",
    "청주",
    "대전",
    "안동",
    "구미",
    "대구수성",
    "경주",
    "진주",
    "김해",
    "창원",
    "서산",
    "당진",
    "전북",
    "익산",
    "전주",
    "제주",
    "광주",
    "부산",
  ];
  return (
    <>
      <SubTitle
        src={"/images/subTitle1.webp"}
        title={"회사소개"}
        eng={"About us"}
      />
      <AboutBtn id={0} />
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36">
        <div className="flex justify-center items-center gap-10">
          <div className="relative w-fit h-full ">
            <img
              src="/images/logo.webp"
              alt="(주)카이노스바이오케미칼"
              className="!relative w-full h-auto max-w-44 object-contain"
              width={285}
              height={67}
            />
          </div>
          <div className="relative w-fit h-full">
            <img
              src="/images/subAbout1.webp"
              alt="홍연사세정제"
              className="!relative w-full h-auto max-w-28 object-contain"
              width={214}
              height={144}
            />
          </div>
        </div>
        <div className="relative w-full h-full my-10 lg:my-14 max-w-screen-xl mx-auto text-center">
          <h4 className="font-normal mb-7 lg:mb-14">
            카이노스 Bio 케미칼을 선택한다는 것,
            <br />
            우리 후손들에게 깨끗한 환경을 물려줄 수 있는{" "}
            <br className="hidden lg:block" />
            가장 손쉽고 가치있는 일입니다.
          </h4>
          <div className="relative w-full h-full">
            <img
              src="/images/subAbout2.webp"
              alt="사람과 환경을 함께 생각한다면"
              className="!relative w-auto h-full max-h-10 mx-auto object-contain"
            />
          </div>
        </div>
        <div className="lg:flex justify-center items-start gap-3 lg:gap-10 relative w-full h-full max-w-[1200px] mx-auto">
          <div data-aos="fade-right">
            <img
              src="/images/aboutMap.webp"
              alt="카이노스 바이오케미칼 국내 전지역 총판·지점 현황 지도"
              width={704}
              height={1116}
              className="!relative w-full h-full object-contain max-h-96 lg:max-h-none my-10 lg:my-0"
            />
          </div>
          <div data-aos="fade-left">
            {/* <img
              src="/images/aboutMap2.webp"
              alt="map"
              width={845}
              height={1076}
            /> */}

            <h3 className="font-normal leading-normal mb-10">
              국내&nbsp;전지역&nbsp;어디라도&nbsp;해결&nbsp;가능합니다.
              <br />
              총판&nbsp;·&nbsp;지점&nbsp;현황
            </h3>
            <div className="grid grid-cols-3 grid-row-10 gap-3">
              {mapList.map((v, i) => (
                <div className="button button--isi relative w-full h-full bg-font text-white rounded-full text-center cursor-pointer">
                  <p className="py-1.5">{v}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutCompany;
